const cache = new Map(); // fileId -> { url, name, type }

export function getFileEntry(fileId) {
  return cache.get(fileId) || null;
}

export function setFileEntry(fileId, entry) {
  // If we’re replacing, revoke the old URL to avoid leaks
  const prev = cache.get(fileId);
  if (prev?.url && prev.url !== entry.url) {
    try { URL.revokeObjectURL(prev.url); } catch {}
  }
  cache.set(fileId, entry);
}

export function revokeFileEntry(fileId) {
  const entry = cache.get(fileId);
  if (entry?.url) {
    try { URL.revokeObjectURL(entry.url); } catch {}
  }
  cache.delete(fileId);
}

// optional: clear all on app unload
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    for (const [id, e] of cache) {
      try { URL.revokeObjectURL(e.url); } catch {}
    }
    cache.clear();
  });
}
